import { get, post } from "shared/data";

export const getDuplicateStagingTask = (key) => {
    return get(`/duplicate-match/staging-task/${key}`);
};

export const getPotentialMatches = (taskContextKey) => {
    return get(`/duplicate-match/potential-matches/${taskContextKey}`);
};

export const getDuplicateStagingAttributeGroups = () => {
    return get("/coding/attributes?groups=DuplicateMatch&includeInvisible=true");
};

export const getImageCompareAttributeGroups = () => {
    return get("/coding/attributes?groups=ImageComparison&includeInvisible=true");
};

export const updateLastOpenedDuplicate = (taskKey) => {
    post(`/duplicate-match/staging-task/lastopened/${taskKey}`);
};

export const saveMatchType = (taskContextKey, matchType, matchesTaskContextKey) => {
    const payload = {
        matchedProductTaskContextKey: matchesTaskContextKey,
        productMatchType: matchType,
    };
    post(`/duplicate-match/${taskContextKey}`, payload);
};

export const getDuplicateMatches = (taskContextKey) => {
    return get(`/duplicate-match/${taskContextKey}`);
};
